// GENERATED FILE - DO NOT MODIFY

export enum WorkTypeDto {
    Office = "Office",
    Remote = "Remote",
    Unavailable = "Unavailable",
    Away = "Away",
}